<div [ngClass]="nativeSectionsService.getClassByLiteralId(dashboardId)">
  <span
    [ngClass]="[
      noDataValues.includes(data) ? 'no-data' : 'data',
      dataHovered ? (cellLayoutType | lowercase) : '',
    ]"
    [innerHTML]="data"></span>
</div>
